export default __webpack_public_path__ + "static/media/deedee-01.19e4f6e4.jpg";